import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import NonITRecruitment from '../NonITRecruitment/NonITRecruitment'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Non-IT Recruitment" />
                <NonITRecruitment />
                <Footer />
            </div>
        </>
    )
}

export default Main